import Select from "react-select";
import select_styles from "../../../../../../../../layouts/elements";
import React from "react";
import {useTranslation} from "react-i18next";

export default function MusiciansList(props) {
    const {
        instrument,
        countInstr,
        musiciansList,
        musicians,
        changeMusicianHandler,
        numer_participants,
        number_staff
    } = props
    const {t} = useTranslation();

    const options_list = musiciansList && musiciansList.length > 0
        ? [{"value": "0000", "label": "-- clear --"}, ...musiciansList,]
        : [{"value": "0000", "label": "-- clear --"}];

    const selValue = (position) => {
        if (musicians && musicians[instrument]) {
            return musicians[instrument].find(el => el.position === position) || {}
        }
        return {}
    }

    const musicianSelectPosition = (index, class_name) => {
        return  <Select
                key={`${instrument}-${index}`}
                placeholder={t("Wybierz muzyka") + " *"}
                closeMenuOnSelect={true}
                isMulti={false}
                options={options_list}
                value={selValue(index)}
                onChange={val => changeMusicianHandler(val, instrument, index)}
                className={class_name}
                styles={select_styles}
                unstyled
            />
    }

    const dynamicMusicianFields = Array.from({length: countInstr}, (_, index) => (
        musicianSelectPosition(index+1)
    ))
    if (numer_participants >= number_staff) {
        dynamicMusicianFields.push(
            musicianSelectPosition(countInstr+1, "addiMusField")
        );
    }
    if (dynamicMusicianFields.length % 2 !== 0) {
        dynamicMusicianFields.push(
            <p style={{visibility: "hidden"}}>Placeholder</p>
        );
    }

    return (
        <>
            {dynamicMusicianFields.map((field, index) => (
                <div key={`${index}-music`} style={{width: '50%', paddingLeft: '10px', paddingRight: '10px'}}>
                    {field}
                </div>
            ))}
        </>
    )
}